<div class="d-flex">
	<div class="display-6 ms-1 mt-2 mb-1">Employee Schedules</div>
	<div class="ms-auto"></div>
</div>
<p-divider></p-divider>

<div class="card">
	<p-tabView [(activeIndex)]="tabIndex">
		<p-tabPanel headerStyleClass="p-tab-header" [disabled]="tabDisabled(0)" [selected]="selectedTab === 'scheduleList'">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'calendar']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Schedules</div>
			</ng-template>
			<app-employee-schedule-list *ngIf="!denyView"></app-employee-schedule-list>
			<ng-container *ngIf="denyView">
				<ng-template *ngTemplateOutlet="laborSchedulingUnavailable"> </ng-template>
			</ng-container>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" [disabled]="tabDisabled(1)" [selected]="selectedTab === 'shiftList'">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'clock']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Shifts</div>
			</ng-template>
			<app-employee-labor-shift-list *ngIf="!denyView"></app-employee-labor-shift-list>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" [disabled]="tabDisabled(2)" [selected]="selectedTab === 'laborSetup'">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'cogs']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Scheduling Setup</div>
			</ng-template>
			<app-employee-scheduling-setup *ngIf="!denyView"></app-employee-scheduling-setup>
		</p-tabPanel>
	</p-tabView>
</div>

<ng-template #laborSchedulingUnavailable>
	<div class="d-flex w-100 display-12">
		<div class="mx-auto">FocusLink Employee Scheduling is not currently enabled for {{ venueService.subscriptionVenue.value.name }}.</div>
	</div>
	<div class="d-flex w-100 mt-4 display-12">
		<div class="mx-auto">
			Please contact your Focus Service Provider <span class="text-italics">{{ venueService.subscriptionVenue.value.dealer.name }}</span> for more
			information about this service.
		</div>
	</div>
</ng-template>
